import { createReducer } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';
import { MentorshipProgramGuidesSchema } from 'redux/schemas/api/mentoring-program-guides';
import {
  getMentorshipProgramGuides,
} from 'redux/actions/mentoring-program-guides';
import { RootState } from 'redux/schemas';
import { initialRootState } from '.';
import { merge } from 'lodash';
import { replaceArrays } from 'shared/lodash-utils';

const setProgramGuidesActionHandler = (
  state: RootState,
  action: ReturnType<typeof getMentorshipProgramGuides.fulfilled>
) => {
  const normalized = normalize(action.payload, MentorshipProgramGuidesSchema);
  merge(state.models, normalized.entities, replaceArrays);
};

export default createReducer(initialRootState, (builder) => {
  builder
    .addCase(
      getMentorshipProgramGuides.fulfilled,
      setProgramGuidesActionHandler
    );
});
